import React, { useState, useEffect, useRef } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import Pagination from "../../Common/Pagination/Pagination";
import CountUp from "react-countup";
import { useReactToPrint } from "react-to-print";
import { map } from "jquery";

const GovtOrderDispatch = ({ selectedDate }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [status, setStatus] = useState("all");
  const [pageSize, setPageSize] = useState(10);
  const [statusOrder, setStatusOrder] = useState([]);
  const [govtCountData, setGovtCountData] = useState([]);
  const [printIndex, setPrintIndex] = useState(null);
  const [table, setTable] = useState("govtOrderDispatch");
  const [company, setCompany] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(startItem + statusOrder?.length - 1, totalRecords);
  const [yardId, setYardId] = useState("");
  const [product, setProduct] = useState([]);
  const [productId, setProductId] = useState("");
  const [yard, setYard] = useState([]);
  const [filterCriteria, setfilterCriteria] = useState({
    company_id: selectedCompanyId ? selectedCompanyId : "",
    dispatch_date: "",
    yard_id: yardId ? yardId : "",
    start_date: "",
    end_date: "",
  });

  const handleFilterChange = (name, value) => {
    setfilterCriteria(() => {
      return {
        ...filterCriteria,
        [name]: value,
      };
    });
  };

  const handleRefreshClick = () => {
    setfilterCriteria({
      company_id: "",
      dispatch_date: "",
      yard_id: "",
      product_id: "",
      start_date: "",
      end_date: "",
    });
    setSelectedCompanyId("");
    setProductId("");
    setYardId("");
  };

  const componentPDF = useRef();
  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    pageStyle: `
      @page {
        size: auto !important;
      }
      @media print {
        table {
          width: 100%;
          border-collapse: collapse;
          border: 1px solid #ddd;
          border-spacing: 0;
          margin-bottom: 10px;
          transform: scale(0.9);
        }
        th, td {
          border: 1px solid #ddd;
          padding: 8px;
        }
      }`,
    documentTitle: "Govt Dispatch Status",
  });

  // const getGovtOrderCount = async () => {
  //   const renewalDate = moment(selectedDate).format("YYYY-MM-DD");
  //   let BASE_URL =
  //     SERVER_URL +
  //     `/api/dispatch-status/govt-dispatch-status-count/${user_id}?date=${filterCriteria?.dispatch_date}&companyId=${selectedCompanyId}`;
  //   const res = await fetch(BASE_URL, {
  //     method: "GET",
  //     headers: {
  //       authorization: `Bearer ${token}`,
  //       "Content-Type": "application/json",
  //     },
  //   });
  //   const result = await res.json();
  //   if (res.ok) {
  //     setGovtCountData(result.data);
  //   } else {
  //     setGovtCountData([]);
  //   }
  // };

  // useEffect(() => {
  //   getGovtOrderCount();
  // }, [selectedCompanyId, selectedDate]);

  const getDispatchStatusData = async () => {
    const BASE_URL = `${SERVER_URL}/api/dispatch-status/private-dispatch-details/${user_id}?dispatch_date=${filterCriteria?.dispatch_date}&take=${pageSize}&skip=${currentPage}&company_id=${selectedCompanyId}&table=${table}&yard_id=${yardId}&product_id=${productId}&start_date=${filterCriteria.start_date}&end_date${filterCriteria.end_date}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setTotalRecords(result.total);
      setStatusOrder(result.data);
    } else {
      setStatusOrder([]);
    }
  };

  useEffect(() => {
    getDispatchStatusData();
  }, [
    currentPage,
    pageSize,
    selectedDate,
    status,
    selectedCompanyId,
    filterCriteria,
  ]);

  useEffect(() => {
    setCurrentPage(1);
  }, [status]);

  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    setCurrentPage(1); // Reset to the first page when page size changes
  };

  const handleYardChange = (e) => {
    const yardId = e.target.value != "" ? parseInt(e.target.value) : "";
    // Update filterCriteria with the selected company's ID
    setYardId(yardId);
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      yard_id: yardId,
    }));
  };
  const handleProductChange = (e) => {
    const productId = e.target.value != "" ? parseInt(e.target.value) : "";
    // Update filterCriteria with the selected company's ID
    setProductId(productId);
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      product_id: productId,
    }));
  };

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setCompany(result.data);
  };

  useEffect(() => {
    getCompany();
  }, []);

  const getYardDetails = async (e) => {
    const companyId = e.target.value ? parseInt(e.target.value) : "";

    // Exit early if companyId is empty
    if (!companyId) {
      setYard([]);
      setYardId("");
      setProduct([]);
      setProductId("");
      setSelectedCompanyId(companyId);
      setfilterCriteria((prevFilterCriteria) => ({
        ...prevFilterCriteria,
        company_id: companyId,
        dispatch_date: "",
      }));
      return;
    }
    setSelectedCompanyId(companyId);
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      company_id: companyId,
      yard_id: "",
      product_id: "",
    }));

    const BASE_URL = `${SERVER_URL}/api/com-yard/single-company-yards/${user_id}/${companyId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();

    if (res.ok) {
      setYard(result.data);
    } else {
      setYard([]);
    }

    const BASEURL = `${SERVER_URL}/api/product/drop-products/${user_id}`;
    const response = await fetch(BASEURL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: companyId,
      }),
    });
    const product_result = await response.json();
    if (res.ok) {
      setProduct(product_result.data);
    } else {
      setProduct([]);
    }
  };
  return (
    <>
      {" "}
      {/* <div className="card mt-4">
        <div className="card-body">
          <div>
            <div
              style={{
                justifyContent: "space-between",
                display: "flex",
              }}
            >
              <p className="card-title">Goverment Dispatch Status</p>
              <div style={{ display: "flex" }}>
                <select
                  className="form-control ml-2"
                  onChange={handleCompanyChange}
                  value={companyId} // Set the value of the dropdown to the companyId state
                >
                  <option value="">Select Company (All)</option>
                  {companyDetails?.map((item, id) => {
                    return (
                      <option
                        key={id}
                        value={item.id}
                      >{`${item.companyName}, ${item.location}`}</option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="d-flex border-md-right flex-grow-1  p-3 item justify-content-center">
                  <i
                    className={`mdi mdi-truck-fast-outline
                  menu-icon mr-4 icon-lg text-danger`}
                  ></i>
                  <div className="d-flex flex-column justify-content-around">
                    <small className="mb-1 text-muted">Total Order</small>
                    <h2>
                      <CountUp
                        end={govtCountData?.activeCount}
                        duration={2}
                        separator=","
                      />
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div className="card mt-3">
        <div className="card-body">
          <div className="status_heading">
            <h5>Govt Dispatch Details Status</h5>
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border ml-2"
                onClick={handleRefreshClick}
              >
                Refresh
                <i
                  className="mdi mdi-refresh"
                  style={{ height: "4px", width: "4px" }}
                ></i>
              </button>
            </span>
          </div>

          <div className="search mb-3">
            <div className="row">
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor="yard">Select Company</label>
                  <select
                    className="form-control form-control-lg"
                    onChange={getYardDetails}
                    value={selectedCompanyId}
                    id="company"
                  >
                    <option value="">Select Company (All)</option>
                    {company &&
                      company?.length > 0 &&
                      company?.map((item, id) => {
                        return (
                          <React.Fragment key={id}>
                            <option
                              value={item.id}
                              key={id}
                            >{`${item.company_name}, ${item.location}`}</option>
                          </React.Fragment>
                        );
                      })}
                  </select>
                </div>
              </div>
              {selectedCompanyId && (
                <div className="col-md-2">
                  <div className="form-group">
                    <label htmlFor="yard">Select Yard</label>
                    <select
                      className="form-control form-control-lg"
                      onChange={handleYardChange}
                      value={yardId}
                      id="yard"
                    >
                      <option value="">Select yard (All)</option>
                      {yard &&
                        yard.length > 0 &&
                        yard?.map((item, id) => {
                          return (
                            <option
                              value={item.id}
                              key={id}
                            >{`${item.yard_name}`}</option>
                          );
                        })}
                    </select>
                  </div>
                </div>
              )}
              {selectedCompanyId && (
                <div className="col-md-2">
                  <div className="form-group">
                    <label htmlFor="product">Select Product</label>
                    <select
                      className="form-control form-control-lg"
                      onChange={handleProductChange}
                      value={productId}
                      id="product"
                    >
                      <option value="">Select Product (All)</option>
                      {product &&
                        product?.length > 0 &&
                        product?.map((item, id) => {
                          return (
                            <option
                              value={item.id}
                              key={id}
                            >{`${item.size}`}</option>
                          );
                        })}
                    </select>
                  </div>
                </div>
              )}
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor="dispatch">Dispatch Date</label>
                  <input
                    type="date"
                    className="form-control form-control-lg"
                    placeholder="Search by Date"
                    max={new Date().toISOString().split("T")[0]}
                    onChange={(e) =>
                      handleFilterChange("dispatch_date", e.target.value)
                    }
                    name="dispatch_date"
                    value={filterCriteria.dispatch_date}
                    id="dispatch"
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor="start">Start Date</label>
                  <input
                    type="date"
                    id="start"
                    className="form-control form-control-lg"
                    placeholder="Search by Date"
                    max={new Date().toISOString().split("T")[0]}
                    onChange={(e) =>
                      handleFilterChange("end_date", e.target.value)
                    }
                    name="end_date"
                    value={filterCriteria.end_date}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor="pro_name_id">End Date</label>
                  <input
                    type="date"
                    className="form-control form-control-lg"
                    placeholder="Search by Date"
                    max={new Date().toISOString().split("T")[0]}
                    onChange={(e) =>
                      handleFilterChange("start_date", e.target.value)
                    }
                    name="start_date"
                    value={filterCriteria.start_date}
                  />
                </div>
              </div>
            </div>
            <p>
              <span className="print_btn d-flex justify-content-end">
                <i
                  className="mdi mdi-printer-eye"
                  style={{ fontSize: "25px" }}
                  onClick={() =>
                    statusOrder && statusOrder?.length > 0
                      ? generatePDF()
                      : null
                  }
                ></i>
              </span>
            </p>
          </div>
          <div className="tkcs-table-container">
            <div
              className="table-responsive table-bordered govt-table"
              style={{
                border: "0.05px solid lightGray",
                width: "auto",
                marginTop: "20px",
              }}
              ref={componentPDF}
            >
              <table className="table">
                <thead>
                  <tr>
                    <th>S.NO</th>
                    <th>Company Name</th>
                    <th>Yard Name</th>
                    <th>Size</th>
                    <th>Dispatch Date</th>
                    <th>Dispatch Qty</th>
                    <th>Shortage Stock</th>
                    <th>Over Stock</th>
                    <th>Damage Stock</th>
                  </tr>
                </thead>
                <tbody>
                  {statusOrder &&
                    statusOrder?.length > 0 &&
                    statusOrder?.map((dispatch, index) => {
                      return (
                        <React.Fragment key={index}>
                          <tr>
                            <td>{index + 1}</td>
                            <td>{dispatch.company_name}</td>
                            <td>{dispatch.yard_name}</td>
                            <td>{dispatch.size}</td>
                            <td>{dispatch.dispatch_date}</td>
                            <td>{dispatch.dispatch_qty}</td>
                            <td>{dispatch.p_shortage_stock}</td>
                            <td>{dispatch.p_over_stock}</td>
                            <td>{dispatch.p_damage_stock}</td>
                          </tr>
                        </React.Fragment>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
          <div style={{ marginTop: "20px" }}>
            <Pagination
              currentPage={currentPage}
              totalRecords={totalRecords}
              pageSize={pageSize}
              totalPages={totalPages}
              startItem={startItem}
              endItem={endItem}
              onPageChange={onPageChange}
              onPageSizeChange={onPageSizeChange}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default GovtOrderDispatch;
